module.exports = __webpack_public_path__ + "assets/img/page3-design-side-nav-expanded-1-1c3e935c.png";